import { Pipe, PipeTransform } from "@angular/core";

@Pipe({ name: "cartIcon", standalone: true })
export class CartIconPipe implements PipeTransform {
  transform(serviceRequestId: string, isInCart: (id: string) => boolean, recentlyAdded?: Set<string>): string {
    if (!isInCart(serviceRequestId)) {
      return "add";
    }

    if (recentlyAdded?.has(serviceRequestId)) {
      return "check";
    }

    return "close";
  }
}

@Pipe({ name: "cartTooltip", standalone: true })
export class CartTooltipPipe implements PipeTransform {
  transform(serviceRequestId: string, isInCart: (id: string) => boolean, recentlyAdded?: Set<string>, alreadyBought = false): string {
    if (!isInCart(serviceRequestId)) {
      return alreadyBought ? "page.risk.tooltip.buyAgain" : "page.risk.tooltip.add";
    }

    if (recentlyAdded?.has(serviceRequestId)) {
      return "page.risk.tooltip.added";
    }

    return "page.risk.tooltip.remove";
  }
}
